import { Input } from '@sib/ui';
import { Search } from '@sib/ui/icons';
import { GlobalSearchPreviousSearches } from './PreviousSearches';
import { GlobalSearchResults } from './Results';
import { GlobalSearchTaskDetailsModal } from './TaskDetailsModal';
import { useGlobalSearchBar } from './hooks';
import {
  GLOBAL_SEARCH_CONTAINER_CLASS_NAME,
  GLOBAL_SEARCH_DROPDOWN_CLASS_NAME,
} from './GlobalSearch.constants';

export const GlobalSearch = () => {
  const {
    containerRef,
    searchTerm,
    trimmedDebouncedTerm,
    recentItems,
    showPreviousSearches,
    showResults,
    buckets,
    isLoading,
    isError,
    showMinLengthHint,
    placeholder,
    selectedTaskId,
    openResults,
    handleSearchChange,
    handleItemSelect,
    closeTaskDetails,
  } = useGlobalSearchBar();

  return (
    <>
      <div ref={containerRef} className={GLOBAL_SEARCH_CONTAINER_CLASS_NAME}>
        <Input
          startAdornment={<Search className="size-4" />}
          className="h-9 w-full"
          placeholder={placeholder}
          fullWidth
          disableAutocomplete
          value={searchTerm}
          onChange={event => handleSearchChange(event.target.value)}
          onFocus={openResults}
        />
        {(showPreviousSearches || showResults) && (
          <div className={GLOBAL_SEARCH_DROPDOWN_CLASS_NAME}>
            {showPreviousSearches ? (
              <GlobalSearchPreviousSearches
                items={recentItems}
                onSelect={handleItemSelect}
              />
            ) : (
              <GlobalSearchResults
                key={trimmedDebouncedTerm}
                buckets={buckets}
                searchTerm={trimmedDebouncedTerm}
                isLoading={isLoading}
                isError={isError}
                showMinLengthHint={showMinLengthHint}
                onItemSelect={handleItemSelect}
              />
            )}
          </div>
        )}
      </div>
      <GlobalSearchTaskDetailsModal
        taskId={selectedTaskId}
        onClose={closeTaskDetails}
      />
    </>
  );
};
